module.exports = __webpack_public_path__ + "img/pin-rubi.0914f968.png";